import { motion } from 'framer-motion';

const meetings = [
  {
    n: '01',
    t: 'Architecture review',
    d: 'Map your current stack to the cognition plane: inference layer, agent runtime, memory, tools, gateway, evals, observability. Where are the holes? Where is the glue code that an integrated primitive would delete?',
  },
  {
    n: '02',
    t: 'Risk officer',
    d: 'Walk the 15-row matrix. For each row, name a control owner. Where you cannot name one, that is your next hire.',
  },
  {
    n: '03',
    t: 'One workflow',
    d: 'Pick a single bounded workflow and move it deliberately up the autonomy ladder. Write the evals first. Instrument with OpenTelemetry GenAI on day one. Set a token budget. Ship to rung 2, then rung 3, only when the evals say you can.',
  },
];

export default function Closing() {
  return (
    <section className="mx-auto max-w-6xl px-6 py-32 border-t hairline">
      <h2 className="font-display text-4xl md:text-6xl tracking-tight2 mb-4">
        What to do on Monday.
      </h2>
      <p className="text-ink-dim text-lg max-w-2xl mb-12">
        If you read this far you do not need a peroration. You need three meetings.
      </p>
      <div className="grid md:grid-cols-3 gap-6 mb-16">
        {meetings.map((m, i) => (
          <motion.div
            key={m.n}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.4, delay: i * 0.08 }}
            className="rounded-2xl border hairline bg-elevated/60 p-7"
          >
            <div className="font-mono text-[11px] text-accent tracking-widest mb-3">
              MEETING {m.n}
            </div>
            <h3 className="font-display text-2xl tracking-tight2 mb-3">
              {m.t}
            </h3>
            <p className="text-ink-dim text-[15px] leading-relaxed">{m.d}</p>
          </motion.div>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="font-display text-xl md:text-2xl tracking-tight2 text-ink max-w-3xl"
      >
        The lifecycle has changed. The teams that win the next decade are the
        ones who notice in time — and the ones who treat evals, agent identity,
        AIBOM, and edge proximity as load-bearing, not optional.
      </motion.p>
      <p className="mt-12 text-sm text-ink-dim italic max-w-3xl">
        One last self-reference. This microsite is itself the demonstration:
        agent-readable at <code className="font-mono text-accent">/llms.txt</code>,
        structured at schema.org, content-negotiated for{' '}
        <code className="font-mono text-accent">text/markdown</code>,
        edge-rendered on Cloudflare Pages, and written for two audiences at
        once. If your site cannot say the same on Monday, that is the first
        item on your list.
      </p>
    </section>
  );
}
